import React from 'react';
import ReactPlayer from 'react-player';
import { Box, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

interface IProps {
  open: boolean;
  onClose: () => void;
  url: string;
}

const useStyles = makeStyles({
  modal: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
});

const VideoPlayer: React.FC<IProps> = ({ open, onClose, url }) => {
  const { modal } = useStyles();
  return (
    <Modal className={modal} open={open} onClick={onClose}>
      <Box
        justifyContent="center"
        alignItems="center"
        style={{ pointerEvents: 'all', zIndex: -1 }}
        onClick={(e) => e.stopPropagation()}
      >
        <ReactPlayer
          url={url}
          controls={true}
          playing={true}
          style={{ outline: '0px' }}
          className={'test'}
        />
      </Box>
    </Modal>
  );
};

export default VideoPlayer;
